<template>
    <v-container>
        <v-row>
            <v-col cols=12>
                <h1 style="text-align:center">Get all the news</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="text-align: center">
                <p>Want to receive all the news and exclusive previews directly on your mail?</p>
                <h2>Drop your mail and join my DOPE fam!</h2>
            </v-col>
            <v-col cols="12">
                <div class="ml-embedded" data-form="qHLJ4B"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {

}
</script>
<style>
#mc_embed_signup
{
    clear:left;
}
.arrow {
    width: 100%;
    transform: scaleY(-1);
}
.button-custom {
    width: 100%;
    min-height:50px;
    background-color: grey
}
.forms {

}
</style>